import { useState } from "react";
import { NutricionCreate } from "./NutricionCreate";
import { useLoaderData, useParams } from "react-router-dom";

import { OpcionesEstadosTratamientos } from '../components/OpcionesEstadosTratamientos';

export function NutricionNew(props) {
  const nutricion = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  // Set number of sesion based on number of items published
  let nutricionLength = nutricion.length;
  let currentSesion = nutricionLength + 1;

  const [nutrResp, setNutrResp] = useState(props.especialistaFullName);
  const [nutrFecha, setNutrFecha] = useState(todayDate);
  const [nutrNumses, setNutrNumses] = useState(currentSesion);
  const [nutrMedio, setNutrMedio] = useState("");

  const [nutrPeso, setNutrPeso] = useState("");
  const [nutrTalla, setNutrTalla] = useState("");

  const [nutrDondcomid, setNutrDondcomid] = useState("");
  const [nutrQuiencomid, setNutrQuiencomid] = useState("");
  const [nutrEnccocRad, setNutrEnccocRad] = useState("");
  const [nutrEnccampRad, setNutrEnccampRad] = useState("");

  const [nutrPichoras, setNutrPichoras] = useState("");
  const [nutrComrap, setNutrComrap] = useState("");
  const [nutrApet, setNutrApet] = useState("");
  const [nutrTrastdig, setNutrTrastdig] = useState("");
  const [nutrTrastdigEsp, setNutrTrastdigEsp] = useState("");
  const [nutrAlimmalestRad, setNutrAlimmalestRad] = useState("");
  const [nutrAlimmalestEsp, setNutrAlimmalestEsp] = useState("");
  const [nutrAlergalimRad, setNutrAlergalimRad] = useState("");
  const [nutrAlergalimEsp, setNutrAlergalimEsp] = useState("");
  const [nutrPesotiempRad, setNutrPesotiempRad] = useState("");
  const [nutrPesotiempEsp, setNutrPesotiempEsp] = useState("");
  const [nutrSuplalimRad, setNutrSuplalimRad] = useState("");
  const [nutrSuplalimEsp, setNutrSuplalimEsp] = useState("");

  const [nutrDigest, setNutrDigest] = useState("");
  const [nutrRetliqu, setNutrRetliqu] = useState("");
  const [nutrHorarcom, setNutrHorarcom] = useState("");
  const [nutrEvaldesay, setNutrEvaldesay] = useState("");
  const [nutrEvalman, setNutrEvalman] = useState("");
  const [nutrEvalcomid, setNutrEvalcomid] = useState("");
  const [nutrEvalmeri, setNutrEvalmeri] = useState("");
  const [nutrEvalcena, setNutrEvalcena] = useState("");
  const [nutrEvallact, setNutrEvallact] = useState("");
  const [nutrEvalverd, setNutrEvalverd] = useState("");
  const [nutrEvalfrit, setNutrEvalfrit] = useState("");
  const [nutrEvalcarn, setNutrEvalcarn] = useState("");
  const [nutrEvalfrut, setNutrEvalfrut] = useState("");
  const [nutrEvalsals, setNutrEvalsals] = useState("");
  const [nutrEvalpesc, setNutrEvalpesc] = useState("");
  const [nutrEvallegu, setNutrEvallegu] = useState("");
  const [nutrEvalcafte, setNutrEvalcafte] = useState("");
  const [nutrEvalhuev, setNutrEvalhuev] = useState("");
  const [nutrEvalcere, setNutrEvalcere] = useState("");
  const [nutrEvaldulc, setNutrEvaldulc] = useState("");
  const [nutrEvalemb, setNutrEvalemb] = useState("");
  const [nutrEvalagua, setNutrEvalagua] = useState("");
  const [nutrEvalfsec, setNutrEvalfsec] = useState("");
  const [nutrEvalrefr, setNutrEvalrefr] = useState("");
  const [nutrObs, setNutrObs] = useState("");
  const [nutrEstado, setNutrEstado] = useState('seguimiento');
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  const submitNutricion = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      nutrResp,
      nutrFecha,
      nutrNumses,
      nutrMedio,

      nutrPeso,
      nutrTalla,

      nutrDondcomid,
      nutrQuiencomid,
      nutrEnccocRad,
      nutrEnccampRad,

      nutrPichoras,
      nutrComrap,
      nutrApet,
      nutrTrastdig,
      nutrTrastdigEsp,
      nutrAlimmalestRad,
      nutrAlimmalestEsp,
      nutrAlergalimRad,
      nutrAlergalimEsp,
      nutrPesotiempRad,
      nutrPesotiempEsp,
      nutrSuplalimRad,
      nutrSuplalimEsp,

      nutrDigest,
      nutrRetliqu,
      nutrHorarcom,
      nutrEvaldesay,
      nutrEvalman,
      nutrEvalcomid,
      nutrEvalmeri,
      nutrEvalcena,
      nutrEvallact,
      nutrEvalverd,
      nutrEvalfrit,
      nutrEvalcarn,
      nutrEvalfrut,
      nutrEvalsals,
      nutrEvalpesc,
      nutrEvallegu,
      nutrEvalcafte,
      nutrEvalhuev,
      nutrEvalcere,
      nutrEvaldulc,
      nutrEvalemb,
      nutrEvalagua,
      nutrEvalfsec,
      nutrEvalrefr,
      nutrObs,
      nutrEstado,
      tratamientoId,
      pacienteId
    );
    try {
      await NutricionCreate(
        nutrResp,
        nutrFecha,
        nutrNumses,
        nutrMedio,

        nutrPeso,
        nutrTalla,

        nutrDondcomid,
        nutrQuiencomid,
        nutrEnccocRad,
        nutrEnccampRad,

        nutrPichoras,
        nutrComrap,
        nutrApet,
        nutrTrastdig,
        nutrTrastdigEsp,
        nutrAlimmalestRad,
        nutrAlimmalestEsp,
        nutrAlergalimRad,
        nutrAlergalimEsp,
        nutrPesotiempRad,
        nutrPesotiempEsp,
        nutrSuplalimRad,
        nutrSuplalimEsp,

        nutrDigest,
        nutrRetliqu,
        nutrHorarcom,
        nutrEvaldesay,
        nutrEvalman,
        nutrEvalcomid,
        nutrEvalmeri,
        nutrEvalcena,
        nutrEvallact,
        nutrEvalverd,
        nutrEvalfrit,
        nutrEvalcarn,
        nutrEvalfrut,
        nutrEvalsals,
        nutrEvalpesc,
        nutrEvallegu,
        nutrEvalcafte,
        nutrEvalhuev,
        nutrEvalcere,
        nutrEvaldulc,
        nutrEvalemb,
        nutrEvalagua,
        nutrEvalfsec,
        nutrEvalrefr,
        nutrObs,
        nutrEstado,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../nutricion/${val.id}`);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitNutricion}>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='nutrResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='nutrResp'
                  required
                  type='text'
                  value={nutrResp}
                  onChange={(e) => setNutrResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='nutrFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='nutrFecha'
                  required
                  type='date'
                  value={nutrFecha}
                  onChange={(e) => setNutrFecha(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='nutrNumses'>Número de sesión</label>
              <div className='control'>
                <input
                  className='input'
                  id='nutrNumses'
                  required
                  disabled
                  type='number'
                  value={nutrNumses}
                  onChange={(e) => setNutrNumses(e.target.value)}
                />
              </div>
            </div>

            <div className='field'>
              <label htmlFor='nutrMedio'>Medio</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='nutrMedio'
                    required
                    name='nutrMedio'
                    defaultValue=''
                    onChange={(e) => setNutrMedio(e.target.value)}
                  >
                    <option disabled value=''>
                      -- Selecciona una opción --
                    </option>
                    <option value='presencial'>Presencial</option>
                    <option value='videoconferencia'>Videoconferencia</option>
                  </select>
                </div>
              </div>
            </div>

            {(props.userRole.includes('administrador')) && (
            <div className='field'>
              <label htmlFor='nutrEstado'>Estado de seguimiento</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='nutrEstado'
                    name='nutrEstado'
                    value={nutrEstado}
                    onChange={(e) => setNutrEstado(e.target.value)}
                  >
                    { OpcionesEstadosTratamientos.map((option) => (
                      <option
                        key={option.value}
                        value={option.value}
                        disabled={option.disabled}
                      >
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            )}
          </div>

          {nutrNumses === 1 ? (
            <>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='nutrPeso'>Peso</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='nutrPeso'
                      required
                      type='text'
                      value={nutrPeso}
                      onChange={(e) => setNutrPeso(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrTalla'>Talla</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='nutrTalla'
                      required
                      type='text'
                      value={nutrTalla}
                      onChange={(e) => setNutrTalla(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='nutrDondcomid'>
                    ¿Dónde suele realizar las principales comidas?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrDondcomid'
                        required
                        name='nutrDondcomid'
                        defaultValue=''
                        onChange={(e) => setNutrDondcomid(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='bar-rest'>Bar/Restaurante</option>
                        <option value='dom-prop'>Domicilio propio</option>
                        <option value='casa-famil'>Casa de familiares</option>
                        <option value='otros'>Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrQuiencomid'>
                    ¿Con quién realiza las comidas?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrQuiencomid'
                        required
                        name='nutrQuiencomid'
                        defaultValue=''
                        onChange={(e) => setNutrQuiencomid(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='solo'>Solo</option>
                        <option value='con-famil'>Con familiares</option>
                        <option value='con-comp-trab'>
                          Con compañeros de trabajo
                        </option>
                        <option value='con-amig'>Con amigos</option>
                        <option value='otros'>Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field key' data-key={nutrEnccocRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Se encarga de cocinar?
                    </label>
                    <label className='radio' htmlFor='nutrEnccocRadSi'>
                      <input
                        id='nutrEnccocRadSi'
                        name='nutrEnccocRad'
                        type='radio'
                        value='Si'
                        checked={nutrEnccocRad === "Si"}
                        onChange={(e) => setNutrEnccocRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='nutrEnccocRadNo'>
                      <input
                        id='nutrEnccocRadNo'
                        name='nutrEnccocRad'
                        type='radio'
                        value='No'
                        checked={nutrEnccocRad === "No"}
                        onChange={(e) => setNutrEnccocRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={nutrEnccampRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Se encarga de hacer la compra?
                    </label>
                    <label className='radio' htmlFor='nutrEnccampRadSi'>
                      <input
                        id='nutrEnccampRadSi'
                        name='nutrEnccampRad'
                        type='radio'
                        value='Si'
                        checked={nutrEnccampRad === "Si"}
                        onChange={(e) => setNutrEnccampRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='nutrEnccampRadNo'>
                      <input
                        id='nutrEnccampRadNo'
                        name='nutrEnccampRad'
                        type='radio'
                        value='No'
                        checked={nutrEnccampRad === "No"}
                        onChange={(e) => setNutrEnccampRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field key' data-key={nutrPichoras?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Suele picar entre horas?
                    </label>
                    <label className='radio' htmlFor='nutrPichoras01'>
                      <input
                        id='nutrPichoras01'
                        name='nutrPichoras'
                        type='radio'
                        value='Si'
                        checked={nutrPichoras === "Si"}
                        onChange={(e) => setNutrPichoras(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='nutrPichoras02'>
                      <input
                        id='nutrPichoras02'
                        name='nutrPichoras'
                        type='radio'
                        value='No'
                        checked={nutrPichoras === "No"}
                        onChange={(e) => setNutrPichoras(e.target.value)}
                      />
                      No
                    </label>
                    <label className='radio' htmlFor='nutrPichoras03'>
                      <input
                        id='nutrPichoras03'
                        name='nutrPichoras'
                        type='radio'
                        value='A veces'
                        checked={nutrPichoras === "A veces"}
                        onChange={(e) => setNutrPichoras(e.target.value)}
                      />
                      A veces
                    </label>
                  </div>
                </div>

                <div className='field key' data-key={nutrComrap?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Come demasiado rápido?
                    </label>
                    <label className='radio' htmlFor='nutrComrap01'>
                      <input
                        id='nutrComrap01'
                        name='nutrComrap'
                        type='radio'
                        value='Si'
                        checked={nutrComrap === "Si"}
                        onChange={(e) => setNutrComrap(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='nutrComrap02'>
                      <input
                        id='nutrComrap02'
                        name='nutrComrap'
                        type='radio'
                        value='No'
                        checked={nutrComrap === "No"}
                        onChange={(e) => setNutrComrap(e.target.value)}
                      />
                      No
                    </label>
                    <label className='radio' htmlFor='nutrComrap03'>
                      <input
                        id='nutrComrap03'
                        name='nutrComrap'
                        type='radio'
                        value='A veces'
                        checked={nutrComrap === "A veces"}
                        onChange={(e) => setNutrComrap(e.target.value)}
                      />
                      A veces
                    </label>
                  </div>
                </div>

                <div className='field key' data-key={nutrApet?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>¿Cómo es su apetito?</label>
                    <label className='radio' htmlFor='nutrApet01'>
                      <input
                        id='nutrApet01'
                        name='nutrApet'
                        type='radio'
                        value='Bueno'
                        checked={nutrApet === "Bueno"}
                        onChange={(e) => setNutrApet(e.target.value)}
                      />
                      Bueno
                    </label>
                    <label className='radio' htmlFor='nutrApet02'>
                      <input
                        id='nutrApet02'
                        name='nutrApet'
                        type='radio'
                        value='Malo'
                        checked={nutrApet === "Malo"}
                        onChange={(e) => setNutrApet(e.target.value)}
                      />
                      Malo
                    </label>
                    <label className='radio' htmlFor='nutrApet03'>
                      <input
                        id='nutrApet03'
                        name='nutrApet'
                        type='radio'
                        value='Regular'
                        checked={nutrApet === "Regular"}
                        onChange={(e) => setNutrApet(e.target.value)}
                      />
                      Regular
                    </label>
                  </div>
                </div>

                <div className='field key' data-key={nutrTrastdig?.toString()}>
                  <label htmlFor='nutrTrastdig'>
                    ¿Suele padecer de algún trastorno digestivo?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrTrastdig'
                        required
                        name='nutrTrastdig'
                        defaultValue=''
                        onChange={(e) => setNutrTrastdig(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='pasad'>Sí, en el pasado</option>
                        <option value='si-actua'>Sí actualmente</option>
                        <option value='si-pasad-actua'>
                          Sí, en el pasado y actualmente
                        </option>
                        <option value='no'>No</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='nutrTrastdigEsp'>Especificar</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrTrastdigEsp'
                        name='nutrTrastdigEsp'
                        defaultValue=''
                        onChange={(e) => setNutrTrastdigEsp(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='estren'>Estreñimiento</option>
                        <option value='diarr'>Diarrea</option>
                        <option value='gastr'>Gastritis</option>
                        <option value='indig'>Indigestión</option>
                        <option value='ulce'>Úlcera</option>
                        <option value='digestp'>Digestiones pesadas</option>
                        <option value='otros'>Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                {/* AQUI FALTAN 4 RADIO BUTTONS ¿toma alimentos...*/}
                <div
                  className='field key'
                  data-key={nutrAlimmalestRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Toma alimentos que le causen malestar?
                    </label>
                    <label className='radio' htmlFor='nutrAlimmalestRadSi'>
                      <input
                        id='nutrAlimmalestRadSi'
                        name='nutrAlimmalestRad'
                        type='radio'
                        value='Si'
                        checked={nutrAlimmalestRad === "Si"}
                        onChange={(e) => setNutrAlimmalestRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='nutrAlimmalestRadNo'>
                      <input
                        id='nutrAlimmalestRadNo'
                        name='nutrAlimmalestRad'
                        type='radio'
                        value='No'
                        checked={nutrAlimmalestRad === "No"}
                        onChange={(e) => setNutrAlimmalestRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='nutrAlimmalestEsp'>
                    Malestar - Especificar
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='nutrAlimmalestEsp'
                      type='text'
                      value={nutrAlimmalestEsp}
                      onChange={(e) => setNutrAlimmalestEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={nutrAlergalimRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Padece de alguna alergia alimentaria?
                    </label>
                    <label className='radio' htmlFor='nutrAlergalimRadSi'>
                      <input
                        id='nutrAlergalimRadSi'
                        name='nutrAlergalimRad'
                        type='radio'
                        value='Si'
                        checked={nutrAlergalimRad === "Si"}
                        onChange={(e) => setNutrAlergalimRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='nutrAlergalimRadNo'>
                      <input
                        id='nutrAlergalimRadNo'
                        name='nutrAlergalimRad'
                        type='radio'
                        value='No'
                        checked={nutrAlergalimRad === "No"}
                        onChange={(e) => setNutrAlergalimRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='nutrAlergalimEsp'>
                    Alergia - Especificar
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='nutrAlergalimEsp'
                      type='text'
                      value={nutrAlergalimEsp}
                      onChange={(e) => setNutrAlergalimEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={nutrPesotiempRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Mantiene su peso estable a lo largo del tiempo?
                    </label>
                    <label className='radio' htmlFor='nutrPesotiempRadSi'>
                      <input
                        id='nutrPesotiempRadSi'
                        name='nutrPesotiempRad'
                        type='radio'
                        value='Si'
                        checked={nutrPesotiempRad === "Si"}
                        onChange={(e) => setNutrPesotiempRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='nutrPesotiempRadNo'>
                      <input
                        id='nutrPesotiempRadNo'
                        name='nutrPesotiempRad'
                        type='radio'
                        value='No'
                        checked={nutrPesotiempRad === "No"}
                        onChange={(e) => setNutrPesotiempRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='nutrPesotiempEsp'>Peso - Especificar</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='nutrPesotiempEsp'
                      type='text'
                      value={nutrPesotiempEsp}
                      onChange={(e) => setNutrPesotiempEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={nutrSuplalimRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Toma algún suplemento vitamínico o mineral?
                    </label>
                    <label className='radio' htmlFor='nutrSuplalimRadSi'>
                      <input
                        id='nutrSuplalimRadSi'
                        name='nutrSuplalimRad'
                        type='radio'
                        value='Si'
                        checked={nutrSuplalimRad === "Si"}
                        onChange={(e) => setNutrSuplalimRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='nutrSuplalimRadNo'>
                      <input
                        id='nutrSuplalimRadNo'
                        name='nutrSuplalimRad'
                        type='radio'
                        value='No'
                        checked={nutrSuplalimRad === "No"}
                        onChange={(e) => setNutrSuplalimRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field lock'>
                  <label htmlFor='nutrSuplalimEsp'>
                    Suplemento - Especificar
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='nutrSuplalimEsp'
                      type='text'
                      value={nutrSuplalimEsp}
                      onChange={(e) => setNutrSuplalimEsp(e.target.value)}
                    />
                  </div>
                </div>

                <div className='field'>
                  <label htmlFor='nutrDigest'>Digestión- Nutrición</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrDigest'
                        required
                        name='nutrDigest'
                        defaultValue=''
                        onChange={(e) => setNutrDigest(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='no-pat-bien'>
                          No hay patología digestiva y se nutre bien
                        </option>
                        <option value='no-pat-med'>
                          No hay patología digestiva y se nutre medianamente
                          bien
                        </option>
                        <option value='no-pat-mal'>
                          No hay patología digestiva y se nutre mal
                        </option>
                        <option value='pat-bien'>
                          Hay patología digestiva y se nutre bien
                        </option>
                        <option value='pat-med'>
                          Hay patología digestiva y se nutre medianamente bien
                        </option>
                        <option value='pat-mal'>
                          Hay patología digestiva y se nutre mal
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrRetliqu'>Retención de líquidos</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrRetliqu'
                        required
                        name='nutrRetliqu'
                        defaultValue=''
                        onChange={(e) => setNutrRetliqu(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='no-hinch-extr'>
                          No sensación de hinchazón en extremidades
                        </option>
                        <option value='hinch-extr'>
                          Sensación de hinchazón en extremidades
                        </option>
                        <option value='hinch-extr-sint-exte'>
                          Sensación de hinchazón en extremidades + presencia de
                          sintomatología externa (bolsas en los ojos, muñecas,
                          tobillos, inflamación...)
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='nutrHorarcom'>
                    ¿Cómo son los horarios de las distintas comidas del día?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrHorarcom'
                        required
                        name='nutrHorarcom'
                        defaultValue=''
                        onChange={(e) => setNutrHorarcom(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='muy-adec'>Muy adecuados</option>
                        <option value='bast-adec'>Bastante adecuados</option>
                        <option value='med-adec'>Medianamente adecuados</option>
                        <option value='poc-adec'>Poco adecuados</option>
                        <option value='in-adec'>Inadecuados</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='nutrEvaldesay'>Evaluación - Desayuno</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvaldesay'
                        required
                        name='nutrEvaldesay'
                        defaultValue=''
                        onChange={(e) => setNutrEvaldesay(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalman'>Evaluación - Media mañana</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalman'
                        required
                        name='nutrEvalman'
                        defaultValue=''
                        onChange={(e) => setNutrEvalman(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalcomid'>Evaluación - Comida</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalcomid'
                        required
                        name='nutrEvalcomid'
                        defaultValue=''
                        onChange={(e) => setNutrEvalcomid(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalmeri'>Evaluación - Merienda</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalmeri'
                        required
                        name='nutrEvalmeri'
                        defaultValue=''
                        onChange={(e) => setNutrEvalmeri(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalcena'>Evaluación - Cena</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalcena'
                        required
                        name='nutrEvalcena'
                        defaultValue=''
                        onChange={(e) => setNutrEvalcena(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvallact'>Evaluación - Lácteos</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvallact'
                        required
                        name='nutrEvallact'
                        defaultValue=''
                        onChange={(e) => setNutrEvallact(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalverd'>
                    Evaluación - Verduras/Hortalizas
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalverd'
                        required
                        name='nutrEvalverd'
                        defaultValue=''
                        onChange={(e) => setNutrEvalverd(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalfrit'>Evaluación - Fritos</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalfrit'
                        required
                        name='nutrEvalfrit'
                        defaultValue=''
                        onChange={(e) => setNutrEvalfrit(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalcarn'>Evaluación - Carne</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalcarn'
                        required
                        name='nutrEvalcarn'
                        defaultValue=''
                        onChange={(e) => setNutrEvalcarn(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalfrut'>Evaluación - Frutas</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalfrut'
                        required
                        name='nutrEvalfrut'
                        defaultValue=''
                        onChange={(e) => setNutrEvalfrut(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalsals'>Evaluación - Salsas</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalsals'
                        required
                        name='nutrEvalsals'
                        defaultValue=''
                        onChange={(e) => setNutrEvalsals(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalpesc'>Evaluación - Pescados</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalpesc'
                        required
                        name='nutrEvalpesc'
                        defaultValue=''
                        onChange={(e) => setNutrEvalpesc(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvallegu'>Evaluación - Legumbres</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvallegu'
                        required
                        name='nutrEvallegu'
                        defaultValue=''
                        onChange={(e) => setNutrEvallegu(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalcafte'>Evaluación - Café/Té</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalcafte'
                        required
                        name='nutrEvalcafte'
                        defaultValue=''
                        onChange={(e) => setNutrEvalcafte(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalhuev'>Evaluación - Huevos</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalhuev'
                        required
                        name='nutrEvalhuev'
                        defaultValue=''
                        onChange={(e) => setNutrEvalhuev(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalcere'>Evaluación - Cereales</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalcere'
                        required
                        name='nutrEvalcere'
                        defaultValue=''
                        onChange={(e) => setNutrEvalcere(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvaldulc'>Evaluación - Dulces</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvaldulc'
                        required
                        name='nutrEvaldulc'
                        defaultValue=''
                        onChange={(e) => setNutrEvaldulc(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalemb'>Evaluación - Embutidos</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalemb'
                        required
                        name='nutrEvalemb'
                        defaultValue=''
                        onChange={(e) => setNutrEvalemb(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalagua'>Evaluación - Agua</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalagua'
                        required
                        name='nutrEvalagua'
                        defaultValue=''
                        onChange={(e) => setNutrEvalagua(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalfsec'>
                    Evaluación - Frutos secos
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalfsec'
                        required
                        name='nutrEvalfsec'
                        defaultValue=''
                        onChange={(e) => setNutrEvalfsec(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrEvalrefr'>Evaluación - Refrescos</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEvalrefr'
                        required
                        name='nutrEvalrefr'
                        defaultValue=''
                        onChange={(e) => setNutrEvalrefr(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='1-punt'>No realiza la comida</option>
                        <option value='2-punt'>
                          Ingiere alguna ración, pero en cantidad insuficiente
                        </option>
                        <option value='3-punt'>
                          Ingiere raciones en cantidades adecuadas
                        </option>
                        <option value='4-punt'>
                          Ingiere raciones en exceso
                        </option>
                        <option value='5-punt'>No sabe, no se acuerda</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          <div className='field'>
            <label className='' htmlFor='nutrObs'>
              Observaciones
            </label>
            <div className='control'>
              <textarea
                className='textarea'
                name='nutrObs'
                id='nutrObs'
                value={nutrObs}
                onChange={(e) => setNutrObs(e.target.value)}
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div id='actions'>
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton} 
        >
                      {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}

        </button>
      </div>
    </>
  );
}
